import url from 'url';

export function urlResolver(urlPath) {
  if (urlPath.substr(0, 1) !== '/') {
    return { pathname: `/${urlPath}` };
  }
  // use current url parsed and only update pathname, this will ensure we pass any query params or url part properly
  const linkUrl = url.parse(window.location.href);
  linkUrl.pathname = urlPath;
  return url.format(linkUrl);
}

export function defaultStorageResolver({
  storage = sessionStorage,
  storageKey,
}) {
  return {
    load: () => {
      return JSON.parse(storage.getItem(storageKey) || 'null');
    },
    save: value => {
      storage.setItem(storageKey, JSON.stringify(value));
    },
  };
}



// WEBPACK FOOTER //
// ./src/common/utils/resolvers/index.js